const rotateColor = (colors = [], i) => colors[i % colors.length];

module.exports = rotateColor;
